import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/public/services/auth.service';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { RouterLink } from '@angular/router';
import { PermissionService } from 'src/app/core/services/permission.service';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';

@Component({
    selector: 'app-dropdown-user',
    templateUrl: './dropdown-user.component.html',
    styleUrls: ['./dropdown-user.component.css'],
    standalone: true,
    imports: [
        RouterLink,
        NzDropDownModule,
        NzAvatarModule
    ]
})
export class DropdownUserComponent implements OnInit {
    userLogged: UserDto | null = null;
    bottomText: string = '';
    userAbbreviation: string = '';

    private readonly permissionService = inject(PermissionService);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly authService = inject(AuthService);

    constructor() { }

    ngOnInit(): void {
        this.userLogged = this.userLoggedService.userLogged;

        this.userAbbreviation = `${this.userLoggedService.userLogged.name ? this.userLoggedService.userLogged.name[0].toLocaleUpperCase() : '' }${this.userLoggedService.userLogged.surname ? this.userLoggedService.userLogged.surname[0].toLocaleUpperCase(): ''}`;

        if (window.location.href.includes('samarplast')) {
            this.bottomText = 'SAMARPLAST | B98704521';
        } else if (window.location.href.includes('roses')) {
            this.bottomText = 'SEÑALIZACIONES ROSES | B96424809';
        } else {
            this.bottomText = 'LOCALHOST | BXXXXXXXX';
        }
    }

    async logout() {
        await this.authService.registerLogout(this.userLogged?.id ?? -1);
        this.authService.logout();
    }

    showOption(navMenuKey: string): boolean {
        const permissionMainKey: string = 'app';

        return this.permissionService.canRead(permissionMainKey, `${navMenuKey}`);
    }
}
